// Reconstructed from production code; original paths and local names were not available.
import axios from "axios";
const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "/api";
const api = axios.create({
  baseURL: API_BASE_URL,
});
api.interceptors.request.use((l) => {
  l.headers = l.headers || {};
  const i = localStorage.getItem("token");
  i && (l.headers.Authorization = `Bearer ${i}`);
  const c = String(l.method || "get").toLowerCase(),
    s = String(l.url || "").split("?")[0];
  c === "get" &&
    s === "/categories" &&
    ((l.params = {
      ...(l.params || {}),
      _fresh: Date.now(),
    }),
    (l.headers["Cache-Control"] = "no-cache"),
    (l.headers.Pragma = "no-cache"));
  return l;
});
export { API_BASE_URL, api };
